import React, { useEffect, useState } from "react";
import { DatePickerButton } from "halifax";
import { TripCategory } from "redmond";
import { DesktopCalendarPicker } from "..";
import { ISetDepartureDate, ISetReturnDate } from "../../../../actions/actions";
import "./styles.scss";

export interface ICalendarPickerButtonProps {
  classes?: string[];
  onClick?: () => void;
  disabled?: boolean;
  saveDatesOnClose?: boolean;
  hasMissingSearchInfoError?: boolean;
  tripCategory: TripCategory;
  departureDate: Date | null;
  returnDate: Date | null;
  setDepartureDate: (date: Date | null) => ISetDepartureDate | void;
  setReturnDate: (date: Date | null) => ISetReturnDate | void;
  minAllowedDate?: Date;
  maxAllowedDate?: Date;
  headerTitle?: JSX.Element | string;
  datesModalOpen: boolean;
  setDatesModalOpen: (open: boolean) => void;
}

export const CalendarPickerButton = ({
  classes = [],
  departureDate,
  returnDate,
  tripCategory,
  disabled,
  saveDatesOnClose,
  hasMissingSearchInfoError,
  setDepartureDate,
  setReturnDate,
  headerTitle,
  onClick: onButtonClick,
  minAllowedDate,
  maxAllowedDate,
  datesModalOpen = false,
  setDatesModalOpen,
}: ICalendarPickerButtonProps) => {
  const [localDepartureDate, setLocalDepartureDate] = useState<Date | null>(
    departureDate
  );
  const [localReturnDate, setLocalReturnDate] = useState<Date | null>(
    returnDate
  );

  useEffect(() => {
    setLocalDepartureDate(departureDate);
    setLocalReturnDate(returnDate);
  }, [datesModalOpen]);

  const onClick = () => {
    if (!disabled) {
      onButtonClick && onButtonClick();
      setDatesModalOpen(true);
    }
  };

  const isRoundTrip = tripCategory === TripCategory.ROUND_TRIP;

  return (
    <DatePickerButton
      startDate={departureDate}
      startLabel={isRoundTrip ? "Departure" : "Departure date"}
      endDate={returnDate}
      endLabel="Return"
      classes={classes}
      renderCalendarPopup={(props) => (
        <DesktopCalendarPicker
          {...props}
          minAllowedDate={minAllowedDate}
          maxAllowedDate={maxAllowedDate}
          departureDate={localDepartureDate}
          returnDate={localReturnDate}
          setDepartureDate={setDepartureDate}
          setReturnDate={setReturnDate}
          isOpen={datesModalOpen}
          closePopup={() => setDatesModalOpen(false)}
          tripCategory={tripCategory}
          saveDatesOnClose={saveDatesOnClose}
          headerTitle={headerTitle}
        />
      )}
      onClick={onClick}
      dateFormat={"ddd MMM D"}
      hideEndDate={!isRoundTrip}
      hasMissingSearchInfoError={hasMissingSearchInfoError}
    />
  );
};
